/** @type {import('@nuxt/types').Plugin} */
export default ({ $axios }, inject) => {
    /** @param {string} slug */
    const getCmsPageData = (slug) => $axios.get(`/api/cms/page?slug=${slug}`);

    inject('getCmsPageData', getCmsPageData);
};
